import { Col, Image, Row, Table } from "antd";
import React from "react";
//import { Link } from "react-router-dom";
import Svg from "../../../components/Svg";
import './index.sass';

export default class Group extends React.Component {
    constructor(props) {
        super(props)
    }


    render() {
        const dataSource = [
            {
                key: '1',
                name: '胡彦斌',
                age: 32,
                address: '西湖区湖底公园1号',
            },
            {
                key: '2',
                name: '胡彦祖',
                age: 42,
                address: '西湖区湖底公园2号',
            },
        ];

        const columns = [
            {
                title: '到货时间',
                dataIndex: 'name',
                key: 'name',
                render: () => {
                    return (
                        1
                    )
                }
            },
            {
                title: '截单时间',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '开团数',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '销售额',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '收入',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '状态',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '操作',
                dataIndex: 'address',
                key: 'address',
                render: (ctx) => {

                    console.log(ctx)
                    return (
                        <ul>
                            <li>停止 </li>
                        </ul>
                    )
                }
            },
        ];
        return (
            <div className='group'>
                {/* 头部 */}
                <div className='userInfo'>

                    <p>首页/</p>
                    <div className='flex user_data'>
                        <div className='user_left flex'>

                            <div className='active_info'>

                                <p className='title'>面包甜点团购，新鲜的面包甜点饼干和糕点咖啡等，五一劳动节前抢购有机会获得小礼品一份...</p>

                                <div className='flex alignCenter timerOver'>
                                    <span className='delivery'>用户自提</span>
                                    <p>10小时前发布，7天2小时59分钟后结束</p>
                                </div>


                                <ul className='flex goods_img'>
                                    <li> <Image className='product_img' /> </li>
                                    <li> <Image className='product_img' /> </li>
                                    <li> <Image className='product_img' /> </li>
                                    <li> <Image className='product_img' /> </li>
                                    <li> <Image className='product_img' /> </li>
                                    <li> <Image className='product_img' /> </li>
                                </ul>



                            </div>

                            <div className='active_desc'>
                                <p>截单时间：到货日前1天，16:00</p>
                                <p>优惠活动：满20元送茶杯蛋糕，满50元送马卡龙1个...</p>
                                <p>返佣比例：10%</p>
                                <p>所属供应商： <Image /> 阿里巴巴供应商</p>
                            </div>



                        </div>
                        <div className='user_right'>

                            <ul className='flex census'>
                                <li>
                                    <label>总参团人数</label>
                                    <p>26</p>
                                </li>
                                <li>
                                    <label>总销售额</label>
                                    <p>26</p>
                                </li>
                                <li>
                                    <label>总佣金</label>
                                    <p>26</p>
                                </li>
                            </ul>

                        </div>
                    </div>

                </div>

                {/* 数据 */}

                <div className='record'>
                    <Row>
                        <Col span='18'>
                            <div className='record-left'>
                                <div className='tableData'>
                                    <Table dataSource={dataSource} columns={columns} />
                                </div>
                            </div>
                        </Col>

                        <Col span='6'>
                            <div className='record-right'>
                                <div className='box'>
                                    <div className='title flex alignCenter'>
                                        <Svg.quick className='svg' />
                                        <p>当前勾选中到货时间的商品列表</p>
                                    </div>
                                    <div className='content'>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }



}